import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuthReducer from './reducers';
import * as fromSwitchToAnotherBusinessProfile from './reducers/switch-to-another-business-profile.reducer';
import * as fromRegisterState from './reducers/register.reducer';
import * as fromGetMarketing from './reducers/get-marketing.reducer';
import * as fromGetRegulatory from './reducers/get-regulatory.reducer';
import * as fromBusinessUserRole from './reducers/business-user-role.reducer';
import * as fromRefreshToken from './reducers/refresh-token.reducer';
import * as fromTermsAndConditions from './reducers/get-terms-and-conditions.reducer';
import * as fromLegalEntitiesForUser from './reducers/legal-entities-for-user.reducer';
import * as fromVerifyEmailReducer from './reducers/verify-email.reducer';
import * as fromValidateTokenReducer from './reducers/validate-token.reducer';
import { fromGetTermsAndConditionsActions } from './actions';

export const authFeatureKey = 'auth';

export interface AuthState {
  [fromAuthReducer.fromRegisterReducer.registerFeatureKey]: fromAuthReducer.fromRegisterReducer.RegisterState;
  [fromAuthReducer.fromLoginReducer.loginFeatureKey]: fromAuthReducer.fromLoginReducer.LoginState;
  [fromAuthReducer.fromLogoutReducer.logoutFeatureKey]: fromAuthReducer.fromLogoutReducer.LogoutState;
  [fromAuthReducer.fromCheckIfRegisteredReducer
    .checkIfRegisteredFeatureKey]: fromAuthReducer.fromCheckIfRegisteredReducer.CheckRegistrationState;
  [fromAuthReducer.fromValidateMobileNumberReducer
    .validateMobileNumberFeatureKey]: fromAuthReducer.fromValidateMobileNumberReducer.ValidatemobileState;
  [fromAuthReducer.fromLoginConfirmReducer.loginConfirmFeatureKey]: fromAuthReducer.fromLoginConfirmReducer.LoginConfirmState;
  [fromAuthReducer.fromResendReducer.resendOtpFeatureKey]: fromAuthReducer.fromResendReducer.ResendOtpState;
  [fromAuthReducer.fromForgotPasscodeReducer
    .forgotPasswordUserNeedsHelpFeatureKey]: fromAuthReducer.fromForgotPasscodeReducer.ForgotPasscode;
  [fromAuthReducer.fromNewUserPasscodeReducer.newUserPasscodeFeatureKey]: fromAuthReducer.fromNewUserPasscodeReducer.NewUserPasscodeState;

  [fromAuthReducer.fromSignUp.signupFeatureKey]: fromAuthReducer.fromSignUp.SignupState;

  [fromAuthReducer.fromValidateGovIdPassport
    .validateGovIdPassportFeatureKey]: fromAuthReducer.fromValidateGovIdPassport.ValidateGovIdPassportState;
  [fromAuthReducer.fromForgotPasscodeVerify.forgotPasswordFeatureKey]: fromAuthReducer.fromForgotPasscodeVerify.ForgotPasscodeVerifyState;
  [fromAuthReducer.fromForgotPasscodeLoginConfirmReducer
    .forgotPasscodeLoginConfirmFeatureKey]: fromAuthReducer.fromForgotPasscodeLoginConfirmReducer.ForgotPasscodeLoginConfirmState;
  [fromAuthReducer.fromForgotPasscodeResendOtp
    .forgotPasscodeResendOtpFeatureKey]: fromAuthReducer.fromForgotPasscodeResendOtp.ForgotPasscodeResendOtpState;
  [fromAuthReducer.fromMarketingOptions.marketingOptionsFeatureKey]: fromAuthReducer.fromMarketingOptions.MarketingOptionState;
  [fromAuthReducer.fromSignupSetPasscodeReducer
    .signupSetPasscodeFeatureKey]: fromAuthReducer.fromSignupSetPasscodeReducer.SignupSetPasscodeState;
  [fromSwitchToAnotherBusinessProfile.switchToAnotherBusinessProfileFeatureKey]: fromSwitchToAnotherBusinessProfile.SwitchToAnotherBusinessProfileState;
  [fromGetMarketing.getMarketingFeatureKey]: fromGetMarketing.MarketingState;
  [fromGetRegulatory.getRegulatoryFeatureKey]: fromGetRegulatory.GetRegulatoryState;
  [fromBusinessUserRole.businessUserRoleFeatureKey]: fromBusinessUserRole.BusinessUserRoleState;
  [fromRefreshToken.refreshTokenFeatureKey]: fromRefreshToken.RefreshTokenState;
  [fromTermsAndConditions.getTermsAndConditionsKey]: fromTermsAndConditions.TermsAndConditionsState;
  [fromLegalEntitiesForUser.legalEntitiesForUserKey]: fromLegalEntitiesForUser.LegalEntitiesForUserState;
  [fromVerifyEmailReducer.verifyEmailFeatureKey]: fromVerifyEmailReducer.VerifyEmailState;
  [fromValidateTokenReducer.validateTokenFeatureKey]: fromValidateTokenReducer.ValidateTokenState;
}

export interface State {
  [authFeatureKey]: AuthState;
}

export function reducers(state: AuthState | undefined, action: Action) {
  return combineReducers({
    [fromAuthReducer.fromRegisterReducer.registerFeatureKey]: fromAuthReducer.fromRegisterReducer.reducer,
    [fromAuthReducer.fromLoginReducer.loginFeatureKey]: fromAuthReducer.fromLoginReducer.reducer,
    [fromAuthReducer.fromLogoutReducer.logoutFeatureKey]: fromAuthReducer.fromLogoutReducer.reducer,
    [fromAuthReducer.fromCheckIfRegisteredReducer.checkIfRegisteredFeatureKey]: fromAuthReducer.fromCheckIfRegisteredReducer.reducer,
    [fromAuthReducer.fromValidateMobileNumberReducer.validateMobileNumberFeatureKey]:
      fromAuthReducer.fromValidateMobileNumberReducer.reducer,
    [fromAuthReducer.fromLoginConfirmReducer.loginConfirmFeatureKey]: fromAuthReducer.fromLoginConfirmReducer.reducer,
    [fromAuthReducer.fromResendReducer.resendOtpFeatureKey]: fromAuthReducer.fromResendReducer.reducer,
    [fromAuthReducer.fromForgotPasscodeReducer.forgotPasswordUserNeedsHelpFeatureKey]: fromAuthReducer.fromForgotPasscodeReducer.reducer,
    [fromAuthReducer.fromNewUserPasscodeReducer.newUserPasscodeFeatureKey]: fromAuthReducer.fromNewUserPasscodeReducer.reducer,

    [fromAuthReducer.fromSignUp.signupFeatureKey]: fromAuthReducer.fromSignUp.reducer,

    [fromAuthReducer.fromValidateGovIdPassport.validateGovIdPassportFeatureKey]: fromAuthReducer.fromValidateGovIdPassport.reducer,
    [fromAuthReducer.fromForgotPasscodeVerify.forgotPasswordFeatureKey]: fromAuthReducer.fromForgotPasscodeVerify.reducer,
    [fromAuthReducer.fromForgotPasscodeLoginConfirmReducer.forgotPasscodeLoginConfirmFeatureKey]:
      fromAuthReducer.fromForgotPasscodeLoginConfirmReducer.reducer,
    [fromAuthReducer.fromForgotPasscodeResendOtp.forgotPasscodeResendOtpFeatureKey]: fromAuthReducer.fromForgotPasscodeResendOtp.reducer,
    [fromAuthReducer.fromMarketingOptions.marketingOptionsFeatureKey]: fromAuthReducer.fromMarketingOptions.reducer,
    [fromAuthReducer.fromSignupSetPasscodeReducer.signupSetPasscodeFeatureKey]: fromAuthReducer.fromSignupSetPasscodeReducer.reducer,
    [fromSwitchToAnotherBusinessProfile.switchToAnotherBusinessProfileFeatureKey]: fromSwitchToAnotherBusinessProfile.reducer,
    [fromGetMarketing.getMarketingFeatureKey]: fromGetMarketing.reducer,
    [fromGetRegulatory.getRegulatoryFeatureKey]: fromGetRegulatory.reducer,
    [fromBusinessUserRole.businessUserRoleFeatureKey]: fromBusinessUserRole.reducer,
    [fromRefreshToken.refreshTokenFeatureKey]: fromRefreshToken.reducer,
    [fromTermsAndConditions.getTermsAndConditionsKey]: fromTermsAndConditions.reducer,
    [fromLegalEntitiesForUser.legalEntitiesForUserKey]: fromLegalEntitiesForUser.reducer,
    [fromVerifyEmailReducer.verifyEmailFeatureKey]: fromVerifyEmailReducer.reducer,
    [fromValidateTokenReducer.validateTokenFeatureKey]: fromValidateTokenReducer.reducer
  })(state, action);
}

export const selectAuthState = createFeatureSelector<State, AuthState>(authFeatureKey);

export const getRegisterState = createSelector(selectAuthState, state => state[fromAuthReducer.fromRegisterReducer.registerFeatureKey]);
export const getVerifyEmailState = createSelector(selectAuthState, state => state[fromVerifyEmailReducer.verifyEmailFeatureKey]);

export const getMarketingState = createSelector(selectAuthState, state => state[fromGetMarketing.getMarketingFeatureKey]);

export const getRegulatoryState = createSelector(selectAuthState, state => state[fromGetRegulatory.getRegulatoryFeatureKey]);

export const getBusinessUserRolesState = createSelector(selectAuthState, state => state[fromBusinessUserRole.businessUserRoleFeatureKey]);

export const getTermsAndConditionsState = createSelector(selectAuthState, state => state[fromTermsAndConditions.getTermsAndConditionsKey]);

export const getLegalEntitiesForUserState = createSelector(
  selectAuthState,
  state => state[fromLegalEntitiesForUser.legalEntitiesForUserKey]
);

export const getValidateTokenState = createSelector(
  selectAuthState,
  state => state[fromValidateTokenReducer.validateTokenFeatureKey]
);
